import React, {useState, useRef, useEffect, useCallback} from 'react'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/src/styles.scss'
import {useTracking} from "../virtual_congress/effects/use_tracking";

export default function PodcastPlayer({field, ...props}) {
    const track = useTracking()
    let url = props.url ? props.url : "https://flave-assets.s3.eu-central-1.amazonaws.com/Ed-Sheeran-I-See-Fire-via-Naijafinix.com_.mp3"
    let identifier = props.identifier ? props.identifier : "default"

    console.log(props)

    let autoPlay = props.autoPlay || false
    let showJumpControls = props.jumpcontrols == "true" || false
    let showLoop = props.showloop == "true" || false
    let loop = showLoop ? [RHAP_UI.LOOP] : []

    console.log("PROPS: ", autoPlay, showJumpControls, showLoop, loop)

    return <AudioPlayer
        autoPlay={autoPlay}
        src={url}
        onPlay={e => {
            track("podcast_player_start", {description: url, identifier: identifier + "_start"}, {event_label: `${identifier}_start > ${url}`})
        }}
        // other props here
        showJumpControls={showJumpControls}
        customAdditionalControls={loop}
    />
}